import { useTranslation } from '@flecto/translations'
import { type CoreLocale } from '@flecto/types'

export type UseSupportedLanguageOptions = {
  locale?: CoreLocale
}

export function useLocaleInfo({ locale }: UseSupportedLanguageOptions) {
  const { t } = useTranslation('shared', { keyPrefix: 'locales_supported' })

  const name = t(`${locale}_name`)
  const flag = t(`${locale}_flag`)

  return { name, flag }
}
